import { render, staticRenderFns } from "./UserAcronymPicker.vue?vue&type=template&id=43dd0e4a&scoped=true&"
import script from "./UserAcronymPicker.vue?vue&type=script&lang=js&"
export * from "./UserAcronymPicker.vue?vue&type=script&lang=js&"
import style0 from "./UserAcronymPicker.vue?vue&type=style&index=0&id=43dd0e4a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43dd0e4a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
installComponents(component, {VAutocomplete})
